import dayjs from "dayjs";
import jalaliday from "jalaliday";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

dayjs.extend(relativeTime);
dayjs.extend(utc);

if (localStorage.getItem("lang") === "fa") {
  dayjs.extend(jalaliday);
  dayjs.calendar("jalali").locale("fa");
}

// Create a simple wrapper function that applies the fix
const fixedDayjs = function(date, format) {
  const instance = dayjs(date, format);
  // تاریخ یک فروردین هزاروچهارصد و چهار => 1742502600000

  if (localStorage.getItem("lang") === "fa" && instance.valueOf() >= 1742502600000) {
    return instance.subtract(1, 'day');
  }
  
  return instance;
};

export default fixedDayjs;